import { render, staticRenderFns } from "./edit-connect-feature.vue?vue&type=template&id=49ad941a&scoped=true"
import script from "./edit-connect-feature.vue?vue&type=script&lang=js"
export * from "./edit-connect-feature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ad941a",
  null
  
)

export default component.exports